import { IS_DEBUG, IS_CLIENT, PRETTY_OUTPUT } from "./config.js";
const logWithName = (...args) => {
    console.log(`[${IS_CLIENT ? 'client' : 'core'}] `, ...args);
};
const logErrorWithName = (...args) => {
    console.error(`[${IS_CLIENT ? 'client' : 'core'}] `, ...args);
};
const preserveLog = Function.prototype.bind.call(console.log, console);
const preserveError = Function.prototype.bind.call(console.error, console);
export const log = (IS_DEBUG ? (PRETTY_OUTPUT ? logWithName : preserveLog) : (_) => { });
export const logError = (IS_DEBUG ? (PRETTY_OUTPUT ? logErrorWithName : preserveError) : (_) => { });
export const getTargetInfo = (target) => {
    const clazzName = target.name ?? target.constructor.name;
    const isStatic = !!target.prototype;
    return [clazzName, isStatic];
};
